export default __webpack_public_path__ + "static/media/SE90.8cf102c5.png";